import styled from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 3, true)};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'section', 3)};
`;
